export default {
  init() {
    // JavaScript to be fired on all pages

    $('.assure-carousel').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        customPaging: () => '<span class="assure-carousel__dot"></span>',
    });


    /*
    

    function colorRequiredFieldIcon(els, classList = '') {

      for (var i = 0; i < els.length; i++) {
         $(els[i]).each(function() {
           charsAsSpans($(this), classList);
         });
      }

    }

    function charsAsSpans(el, elClassList = '') {
      var $newString = '';
      console.log(elClassList);
      for(var i = 0; i < el.text().length; i++) {
         var $char = '<span';
             $char += (elClassList != '' ? ' class="'+elClassList+'"' : '');
             $char += '>';
             $char += el.text().charAt(i);
             $char += '</span>';
         $newString += $char;
      }
      el.html($newString);
    }

    colorRequiredFieldIcon(requiredEls, 'boneless');
    */
   

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //$('html').css('opacity', '1'); 

    let $offcanvasMenuLauncher = $('.offcanvas-menu-launcher');
    let $offcanvasMenuCloser = $('.offcanvas-menu-closer');
    let $body = $('body');
    let $html = $('html');
    let mobBreak = 991;
    //let colBreak = 991;
    let $teamMember = $('.row-team .team-member');

    let $modalCloser = $('.assure-modal__close');
    let $caseStudy = $('.case-study');

    let $nonDesktopHasSubMenuItemsMenuItem = $('.assure-is-tablet .nav-primary .menu-item-has-children > a');
    let $hasDataHref = $('.has-data-href');


    // eslint-disable-next-line no-undef
    let ajaxObj = content;



    let options = {
      byRow: true,
      property: 'height', 
      target: null, 
      remove: false,
    };

    let matchHeightEls = [
       '.services-block__services .service',
       '.home-cta',
       '.resource-block__resources__resource',
       '.case-study',
       '.blog-list__item',
       '.employee-cta',
       '.editable-cta',
    ];

    let requiredEls = [
       '#field_4_11 .gsection_title',
       '#field_3_3 .gsection_title',
       '#field_3_7 .gsection_title',
       '#field_3_10 .gsection_title',
       '#field_3_16 .gfield_label',
    ];

    function colorRequiredFieldIcon(els){
      for (var i = 0; i < els.length; i++) {
        if($(els[i]).length){
          var content = $(els[i]).html();
          content = content.replace('*', '<span class="gfield_required">*</span>');
          $(els[i]).html(content);
        }
      }
    }

    colorRequiredFieldIcon(requiredEls);
    $(document).bind('gform_page_loaded', function(){
      colorRequiredFieldIcon(requiredEls);
      giveSelectBoxesPlaceholderStyleIfIsPlaceholderValue();
    });

    $('.ginput_container select').on('change', function(){
      giveSelectBoxesPlaceholderStyleIfIsPlaceholderValue();
    });
    giveSelectBoxesPlaceholderStyleIfIsPlaceholderValue();

    function giveSelectBoxesPlaceholderStyleIfIsPlaceholderValue() {

      function isPlaceholderText(text) {
        let placeholderTexts = [
          'Select a topic',
          'Number of Employees',
          'Country',
        ];

        var isPlaceholderText = false;
        for(var i = 0; i < placeholderTexts.length; i++) {
          if(text == placeholderTexts[i]) {
            isPlaceholderText = true;
          }
        }

        return isPlaceholderText;
      }
      $('.ginput_container select').each(function(){
        if( isPlaceholderText($(this).find(':selected').text()) ) {
          $(this).css('color', 'rgba(40,40,40,0.5)');
         } else {
          $(this).css('color', '#282828');
         }
      });
      
    }



    $(matchHeightEls.toString()).matchHeight(options);
    scrollToErrorFormOnLoad();

    $offcanvasMenuLauncher.on('click', function() { 

      $html.hasClass('offcanvas-menu-launched') ? closeOffcanvasMenu() : launchOffcanvasMenu();

    });

    $offcanvasMenuCloser.on('click', function() {

      closeOffcanvasMenu();

    });


    $teamMember.on('click', function(e){
      e.preventDefault();

      let $pid = $(this).data('pid');


      $('.assure-modal__team-member').addClass('assure-modal__in');
      $(document).trigger('modalLaunched');
      $('.assure-modal__contents .team-member').html(' ');
      getTeamMember($pid, function($res){
        $('.assure-modal__contents .team-member').html(buildTeamMemberMarkup($res));
        setTimeout(function(){
          $('.assure-modal__team-member').addClass('show-contents');
        }, 10);
      });

    });

    $(document).on('modalLaunched', function(){
      $body.addClass('modal-in');
    });

    $(document).on('modalClosed', function(){
      $body.removeClass('modal-in');
    })

    function buildTeamMemberMarkup(member) {
      var markup = '';

      markup += '<div class="team-member__title">';
      markup +=    '<div class="profile-photo">';
      markup +=     '<img src="'+ member.image +'" />';
      markup +=    '</div>';
      markup +=    '<h1 class="title">' + member.name + '</h1>';
      markup +=    '<p class="designation">' + member.position + ' ' + member.location +  '</p>';
      markup += '</div>';
      markup += '<div class="team-member__body">' + member.bio + '</div>';

      return markup;
    }
    /*
    $nonDesktopHasSubMenuItemsMenuItem.on('click', function(e) {
       e.preventDefault();
       
       if($(this).parent().hasClass('out')){
        // GO TO LINK 
        let $href = $(this).attr('href');
        window.location.href = $href;
       } else {
          $nonDesktopHasSubMenuItemsMenuItem.parent().removeClass('out');
          $(this).parent().addClass('out'); 
       }
    });
    */

    /*
    $nonDesktopHasSubMenuItemsMenuItem.on('hover', function(e) {
       e.preventDefault();
       
       if($(this).parent().hasClass('out')){
        // GO TO LINK 
        let $href = $(this).attr('href');
        window.location.href = $href;
       } else {
          $nonDesktopHasSubMenuItemsMenuItem.parent().removeClass('out');
          $(this).parent().addClass('out'); 
       }
    });*/

    $('.site-body').on('click', function(){
      $nonDesktopHasSubMenuItemsMenuItem.parent().removeClass('out');
    })


    $modalCloser.on('click', function() {
      let $target = $(this).data('target');
      closeModal($target);
    });

    $caseStudy.on('click', function() {
       let $href = $(this).parent().data('href');
       window.location.href = $href;
    });

    $('.service').on('click', function() {
       let $href = $(this).data('href');
       window.location.href = $href;
    });

    $hasDataHref.on('click', function(){
       let $href = $(this).data('href');
       window.location.href = $href;
    })

    $('.assure-modal__team-member .assure-modal__close').on('click', function(e){
      //override normal modal closer behaviour
      e.stopImmediatePropagation();
      let $target = $(this).data('target');
      closeModal($target, function(){
        $('.assure-modal[data-id="'+$target+'"]').removeClass('show-contents');
      });
    })



    function closeModal($target, action){
      $(document).trigger('modalClosed');
      $('.assure-modal[data-id="'+$target+'"]').removeClass('assure-modal__in');
      if(action){
         action();  
      }
      console.log($('.assure-modal[data-id="'+$target+'"]'));
    }


    function launchOffcanvasMenu() {
       $html.addClass('offcanvas-menu-launched');
    }

    function closeOffcanvasMenu() {
       $html.removeClass('offcanvas-menu-launched');
    }


    function getTeamMember($pid, action) {
      $.ajax({
        type: 'GET', 
        url: ajaxObj.ajax_url,
        data: {
          action     : 'get_team_member', 
          queryprops : $pid,
        }, 
        success: function(data) {
          let $res = $.parseJSON(data);
          action($res);
        },
      });
    }


    function scrollToErrorFormOnLoad(){
       if($('.gform_wrapper').length) {
         if($('.gform_wrapper').hasClass('gform_validation_error')) {
            scrollTo('.gform_validation_error', -100);
         }
       }
    }

    

    function scrollTo(selector, offset = 0){
       if(selector) {
         $('html, body').animate({scrollTop:$(selector).offset().top + offset}, 450); 
       } else {
        return;
      }
    }





    $(window).resize(function(){
      
      let $w = $(document).width();

      if($w > mobBreak) {
        closeOffcanvasMenu();
      }

      reverseMasks();

    });

    reverseMasks();




    function showReverseMasks() {

      let browsers = [
         'assure-edge',
         'assure-ie9_or_less',
         'assure-ie',
         'assure-ie11',
      ];

      var showReverseMasks = false;

      for(var i = 0; i < browsers.length; i++) {
        if($body.hasClass(browsers[i])) {
           showReverseMasks = true;
        }
      }

      console.log(showReverseMasks);

      return showReverseMasks;

    }

    function reverseMasks() {
      if(showReverseMasks()) {
        console.log('is');

        maskPageContentBlock();
        maskService();
        employeeCta();
        textBlockImg();
        headerMask();
        headerMaskAB();

      }
    }


    function setMaskSameSizeAsImg($img, $mask) {

      let $h = parseInt($img.css('height'));
      let $w = parseInt($img.css('width'));

      $mask.css('height', ($h.toString() + 'px'));
      $mask.css('width', ($w.toString() + 'px'));      
    }

    function maskPageContentBlock() {

      let $img = $('.page-content-block .col-img img:not(.body-reverse-mask');
      let $mask =  $('.page-content-block .col-img img.body-reverse-mask');
      
      setMaskSameSizeAsImg($img, $mask);
    }

    function maskService(){
      let $img = $('.service .service__img img:not(.body-reverse-mask');
      let $mask =  $('.service .service__img img.body-reverse-mask');
      
      setMaskSameSizeAsImg($img, $mask);
    }

    function employeeCta() {
      let $img = $('.employee-cta .image img:not(.body-reverse-mask');
      let $mask =  $('.employee-cta .image img.body-reverse-mask');
      
      setMaskSameSizeAsImg($img, $mask);
    }

    function textBlockImg() {
      let $img = $('.centered-text-block__img img:not(.body-reverse-mask');
      let $mask =  $('.centered-text-block__img  img.body-reverse-mask');
      
      setMaskSameSizeAsImg($img, $mask);
    }

    function headerMask() {
      let $img = $('.block-heading__featured-image img:not(.header-reverse-mask');
      let $mask =  $('.block-heading__featured-image  img.header-reverse-mask');
      
      setMaskSameSizeAsImg($img, $mask);
    }


    function headerMaskAB() {

     let $mask = $('.mask-variant-b header-reverse-mask, .mask-variant-a header-reverse-mask');
     let $h = parseInt($mask.parent().parent().css('height'));

     $mask.css('height', ($h.toString() + 'px'));
     $mask.css('width', 'auto !important');

    }






  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js